import { useEffect, useState } from 'react';

interface MaintenanceBreakProps {
	downtimeStartAt?: string;
	downtimeEndAt?: string;
}

function useMaintenanceWindowHook(props: MaintenanceBreakProps) {
	const { downtimeEndAt } = props;

	const [timeLeft, setTimeLeft] = useState({
		hours: '00',
		minutes: '00',
		seconds: '00',
	});

	useEffect(() => {
		if (!downtimeEndAt) return;

		const interval = setInterval(() => {
			const end = new Date(downtimeEndAt).getTime();
			const now = new Date().getTime();
			const diff = Math.max(end - now, 0); // Prevent negative time

			const hours = Math.floor(diff / (1000 * 60 * 60));
			const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((diff % (1000 * 60)) / 1000);

			setTimeLeft({
				hours: String(hours).padStart(2, '0'),
				minutes: String(minutes).padStart(2, '0'),
				seconds: String(seconds).padStart(2, '0'),
			});

			if (diff <= 0) clearInterval(interval);
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, [downtimeEndAt]);

	return { timeLeft };
}

export default useMaintenanceWindowHook;
